import { APIS } from "./api_factory";
import axios from 'axios';
import { POST_HEADER } from "./CustomApiHeader";


const ParsedData=()=>{
    const SessionData = window.sessionStorage.getItem("AdminLogin")
    console.log("SessionData,SessionData",SessionData)
    const ParsedData = JSON.parse(SessionData)
    return ParsedData.email
}


export const EmployeeLogin = (email,password,callBack,error)=>{
    axios.get(APIS.EMPLOYEE_LOGIN + email + "&password=" + password)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getAMUCrifReport = (data,callBack,error)=>{
    const headerConfig = {
        headers:POST_HEADER,
    };
    
    axios.post(APIS.GET_AMU_CRIF_REPORT + ParsedData(), data ,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const SendAMUOTP = (mobileNumber,callBack,error)=>{
    axios.get(APIS.SEND_AMU_OTP_BY_MOBILE_NUMBER + mobileNumber)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const VerifyAMUOTP = (mobileNumber,otp,callBack,error)=>{
    axios.get(APIS.VERIFY_AMU_OTP_BY_MOBILE_NUMBER + mobileNumber + "&otp=" + otp)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getAmuAnalysis = (data,callBack,error)=>{
    const headerConfig = {
        headers:POST_HEADER,
    };
    axios.post(APIS.GET_AMU_ANALYSIS ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}